export const updateStayRowTotalLoge = (stayRows, index) => {
    const updatedStayRows = [...stayRows];
    const quantite = updatedStayRows[index].quantite;
    const prixChambre = updatedStayRows[index].prixChambre;
    let totalLoge=0;
    if (quantite && prixChambre) {
        totalLoge = quantite * prixChambre;
    } else {
        totalLoge = 0;
    }
    return totalLoge; 
};
